import {
  Box, Button, CircularProgress, Grid, TextField, Typography
} from '@material-ui/core';
import { ClientDestinationVote } from 'components/ui/ClientDestinationVote';
import { useAsync } from 'hooks/useAsync';
import { ClientDestinationDetails } from 'models/ClientDestinationDetails';
import React, { memo, useEffect, useState } from 'react';
import { clientDestinationService } from 'services/clientDestinationService';
import { formatOneTimeCode } from 'utils/otcFormatter';

export const Vote = memo(() => {
  const [oneTimeCode, setOneTimeCode] = useState('');
  const [resolvedDetails, setResolvedDetails] = useState<ClientDestinationDetails | null>(null);

  const resolve = useAsync(() => clientDestinationService.resolveOneTimeCode(oneTimeCode));

  useEffect(() => {
    if (resolve.isSuccess && resolve.data) {
      setResolvedDetails(resolve.data);
    }
  }, [resolve.isSuccess, resolve.data]);

  if (resolvedDetails) {
    return (
      <Grid container direction="row" justify="center" alignItems="baseline">
        <Grid item sm={12} md={8}>
          <ClientDestinationVote details={resolvedDetails} />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container direction="row" justify="center" alignItems="baseline">
      <Grid item sm={12} md={6}>
        <Box pt={4}>
          <Typography variant="h4" gutterBottom>
            Enter your one-time code
          </Typography>
          <Typography variant="body1" gutterBottom>
            Please enter the one-time code from your notification email or SMS.
          </Typography>
          <Box pt={2}>
            <TextField
              label="One-time code"
              placeholder="XXXX-XXXX"
              variant="outlined"
              fullWidth
              value={oneTimeCode}
              onChange={e => setOneTimeCode(formatOneTimeCode(e.target.value))}
              inputProps={{ maxLength: 9 }}
              disabled={resolve.isLoading}
            />
          </Box>
          {resolve.isError && resolve.error && (
            <Box pt={1}>
              <Typography variant="body2" color="error">
                {resolve?.error?.data?.[0]?.description ?? 'Invalid one-time code. Please try again.'}
              </Typography>
            </Box>
          )}
          <Box pt={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => resolve.exec()}
              disabled={resolve.isLoading || oneTimeCode.trim().length === 0}
              endIcon={resolve.isLoading && <CircularProgress size="1rem" color="inherit" />}
            >
              Continue
            </Button>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
});
